var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14370526081579605843(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d91bb;}.cls-2{fill:#7aaccc;}.cls-3{fill:#2175aa;}.cls-4{fill:#333;}.cls-5{fill:#4d4d4d;}.cls-6{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05 Eraser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_05_Eraser",
    "data-name": "05 Eraser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.38,56.63l-34-34a5.54,5.54,0,0,0-7.84,0L17.62,73.62a5.54,5.54,0,0,0,0,7.84L41.5,105.33A5.54,5.54,0,0,0,45.42,107H65.6a5.54,5.54,0,0,0,3.92-1.62l40.86-40.86A5.54,5.54,0,0,0,110.38,56.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.38 56.63 78.93 25.19 110.38 56.63 110.38 56.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.15,76.14,71.1,25.19a5.54,5.54,0,0,1,7.84,0l-2.52-2.52a5.54,5.54,0,0,0-7.84,0L17.62,73.62a5.54,5.54,0,0,0,0,7.84L20.15,84A5.54,5.54,0,0,1,20.15,76.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.38,56.63l-34-34h0L105.73,52a5.54,5.54,0,0,1,0,7.84l-1.84,1.84a2.14,2.14,0,0,1-3,.05l-34.33-32,34.64,34.64L69.89,95.68,35.25,61,67.09,95.57a2.14,2.14,0,0,1-.06,3c-2.06,2.06-3.3,3.78-6.08,3.78-21.82,0-21.95.53-24.1-1.62l4.64,4.64A5.54,5.54,0,0,0,45.42,107H65.6a5.54,5.54,0,0,0,3.92-1.62l40.86-40.86A5.54,5.54,0,0,0,110.38,56.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 39.74,
    y: 41.57,
    width: 59.12,
    height: 44.34,
    transform: "translate(65.37 -30.33) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.08,27.17,32.72,58.52,35.25,61,66.6,29.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 65.71,
    y: 79.04,
    width: 44.34,
    height: 6.56,
    transform: "translate(-32.47 86.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.13,
    y: 42.18,
    width: 28.34,
    height: 43.12,
    rx: 4,
    ry: 4,
    transform: "translate(163.38 59.82) rotate(135)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14370526081579605843);
export default __webpack_public_path__ + "static/media/14370526081579605843.d241d134.svg";
export { ForwardRef as ReactComponent };